'use client';

import { styled } from '@mui/material';

export const SectionStyle = styled( 'div', {
  shouldForwardProp(propName: PropertyKey): boolean {
    return propName !== 'top' && propName !== 'button';
  },
} )<{ top?: boolean; button?: boolean }>(({ theme, top, button }) => ({
  padding: theme.spacing( top ? 0 : 2, 0, button ? 0 : 3, 0 ),
  [theme.breakpoints.up( 'md' )]: {
    padding: theme.spacing( top ? 0 : 10, 0, button ? 0 : 15, 0 ),
  },
}));
